import { css } from 'styled-components';

import { tokens } from 'containers/Intelligence/theme';

/**
 * PERX3-REDESIGN round 4/7: the one solid primary-button treatment the redesign draws — a black
 * fill, white ink, no border, and a pure-black hover.
 *
 * It is LAYERED on a `$perx3` branch rather than applied through the base rules, because the four
 * solid CTAs in the suite disagree about what they draw with the flag OFF: `GrowthPlannerCta` and
 * `GrowthPlannerSlider` ink `--is-text-primary` on two different fills, `Customer360CustomRange`
 * inks `--is-filter-text`, and one shared pair of tokens could not reproduce all three. Keeping the
 * OFF declarations untouched and adding this block under the flag is what makes the OFF render
 * byte-identical.
 *
 * The hover excludes both disabled spellings the suite uses — the native attribute and the
 * `aria-disabled` the inert CTAs carry — because a `:hover` rule outranks the class-level
 * `background` their disabled branches set.
 */
export const perx3PrimaryButton = css`
  background: ${tokens.color['button-bg']};
  color: ${tokens.color['button-ink']};
  border: none;

  &:hover:not(:disabled):not([aria-disabled='true']) {
    background: ${tokens.color['button-hover-bg']};
  }
`;

export default perx3PrimaryButton;
